<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-img :src="require('../../../assets/our_service/lead-service1.jpg')" style="border-radius: 4px;"></v-img>
    <v-row class="my-10" align="center" justify="center">
      <v-col class="text-center">
        <span class="text-tcdc-green header bold">{{$t('our-service.idea')}}</span>
      </v-col>
    </v-row>
    <v-layout column>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service1-00.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="sub-header2 text-tcdc-grey1 d-flex align-center">
            {{$t('our-service.idea-content')}}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service1-01.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Resource Center</div>
              <span class="text-tcdc-grey1">
                TCDC Resource Center - {{$t('our-service.idea-detail.resource-center')}}
              </span>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service1-02.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Exhibition</div>
              <span class="text-tcdc-grey1">
                {{$t('our-service.idea-detail.exhibition')}}
              </span>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service1-03.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Creative Space</div>
              <span class="text-tcdc-grey1">
                {{$t('our-service.idea-detail.creative-space')}}
              </span>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service1-04.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Material & Design Innovation Center</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.idea-detail.material-design')}}
                <ul>
                  <li class="txt-link" @click="openLink('https://www.materialconnexion.com/bangkok/')">Material ConneXion Bangkok</li>
                  <li>Trend Corner</li>
                  <li class="txt-link" @click="openLink('https://www.tcdcmaterial.com/th/')">TCDC Material Database</li>
                  <li>Grab Sample</li>
                  <li>Thai & Design Innovation</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service1-05.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Maker Space</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.idea-detail.maker-space')}}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service1-06.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Creative Business Service</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.idea-detail.creative-business')}}
                <ul>
                  <li>TCDC Connect</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mb-12>
        <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
          <v-flex md3 mb-5 mb-md-0 mr-md-5 class="d-flex align-center">
            <v-img
                    :src="require('../../../assets/our_service/service1-07.png')"
                    contain
                    :max-height="$vuetify.breakpoint.smAndDown ? 150:300"
            ></v-img>
          </v-flex>
          <v-flex md7 class="d-flex align-center">
            <div>
              <div class="text-tcdc-green bold sub-header2">Programs</div>
              <div class="text-tcdc-grey1">
                {{$t('our-service.idea-detail.programs')}}
                <ul>
                  <li class="txt-link" @click="routeTo('/home')">Seminars</li>
                  <li class="txt-link" @click="routeTo('/home')">Talks</li>
                  <li class="txt-link" @click="routeTo('/home')">Workshops</li>
                </ul>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GreenButton from "../../../components/buttons/GreenButton";
import { mapState } from "vuex";

export default {
  components: {
    // GreenButton
  },
  created() {
    this.items[0].text = this.branchName;
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  methods: {
    openLink(link) {
      window.open(link);
    },
    routeTo(target) {
      this.$router.push(target);
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        href: "/home"
      },
      {
        text: "OUR SERVICE",
        href: '/our-service'
      },
      {
        text: "IDEA GENERATION",
        disabled: true
      }
    ]
  })
};
</script>

<style scoped lang="scss">
  .txt-link {
    cursor: pointer;
  }
  .txt-link:hover {
    color: #2e8037;
  }
</style>
